"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
var RCMethods;
(function (RCMethods) {
    RCMethods["PAIR"] = "PAIR";
})(RCMethods = exports.RCMethods || (exports.RCMethods = {}));
class RCController {
    constructor(host, port, useWss) {
        this.clientName = "rc_controller";
        this.clientVersion = { major: 1, minor: 0, build: 0 };
        this.startImpl = (delegate) => {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                if (this.dmsClient) {
                    throw new Error("The client already exists");
                }
                this.delegate = delegate;
                let promiseIsPending = true;
                this.dmsClient = new __1.DMSWSClient(this.hostname, this.portNumber, this.useWss, this.clientName, this.clientVersion, {
                    onConnectedToDms: () => {
                    },
                    onConnectionAcknowledged: (sender, message) => {
                        promiseIsPending = false;
                        resolve(message.uid);
                        return new Promise(resolve1 => {
                            resolve1();
                        });
                    },
                    onConnectionFailed: (sender, code, reason) => {
                        this.dmsClient = undefined;
                        if (promiseIsPending) {
                            promiseIsPending = false;
                            reject(reason);
                        }
                    },
                    onDisconnectedFromDms: (sender, code, reason) => {
                        var _a;
                        this.dmsClient = undefined;
                        if (promiseIsPending) {
                            promiseIsPending = false;
                            reject(reason);
                        }
                        else {
                            (_a = this.delegate) === null || _a === void 0 ? void 0 : _a.onDisconnected(new Error(reason));
                        }
                    }
                });
                yield this.dmsClient.connect();
            }));
        };
        this.hostname = host;
        this.portNumber = port;
        this.useWss = useWss;
    }
}
exports.default = RCController;
//# sourceMappingURL=RCController.js.map